const PRODUCTION = 'Production Profile';
const PERFORMANCE = 'Performance';
const ESTIMATED = 'Estimated Production';
const WEATHER = 'Weather';
const METER = 'Meter';
const VIEWS = [PRODUCTION, PERFORMANCE, ESTIMATED, WEATHER, METER];

export { PRODUCTION, PERFORMANCE, ESTIMATED, WEATHER, METER };
export default VIEWS;
